module.exports = __webpack_public_path__ + "img/filter-circle-xmark.d7cb2049.svg";